import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireResourceType} from '../umpire-resource-type';
import {UmpireCompetitionSeason} from '../umpire-competition-season';
import {UmpireMatch} from '../umpire-match';

export interface UmpireComponentSchedule
  extends UmpireComponent<UmpireComponentTypeEnum.SCHEDULE> {
  resource_id: string;
  resource_type: UmpireResourceType;
  competition_season: UmpireCompetitionSeason | null;
  matches?: UmpireMatch[];
}
